module.exports = __webpack_public_path__ + "img/categorie_hdtool.7fa9294d.png";